var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDealershipSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1032_37133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7938 8.625H18.1406C17.6984 9.50942 17.1456 10.1727 16.4823 10.836H19.025L19.6883 14.1526H4.21104L4.87435 10.836H7.41705C6.75374 10.1727 6.20098 9.50942 5.75877 8.625H3.10552L2 14.1526V16.3636H3.10552V22.9968H14.1607V16.3636H18.5828V22.9968H20.7938V16.3636H21.8994V14.1526L20.7938 8.625ZM11.9497 20.7857H5.31656V16.3636H11.9497V20.7857Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.709 5.97484C15.709 5.75374 15.709 5.53263 15.5984 5.31153L16.704 4.31656L15.709 2.54773L14.2718 2.98994C13.9402 2.76883 13.6085 2.54773 13.1663 2.32662L12.9452 1H10.9553L10.6236 2.43718C10.1814 2.54773 9.84974 2.76883 9.51808 3.10049L8.08091 2.65828L7.08594 4.31656L8.19146 5.31153C8.19146 5.53263 8.08091 5.75374 8.08091 5.97484C8.08091 6.19594 8.08091 6.41705 8.19146 6.63815L7.08594 7.63312L8.08091 9.40195L9.51808 8.95974C9.84974 9.18085 10.1814 9.40195 10.6236 9.62305L10.9553 10.9497H12.9452L13.2768 9.5125C13.7191 9.40195 14.0507 9.18085 14.3824 8.84919L15.8195 9.2914L16.8145 7.63312L15.709 6.63815C15.709 6.41705 15.709 6.19594 15.709 5.97484ZM11.9502 7.96477C10.8447 7.96477 9.96029 7.08036 9.96029 5.97484C9.96029 4.86932 10.8447 3.9849 11.9502 3.9849C13.0557 3.9849 13.9402 4.86932 13.9402 5.97484C13.9402 7.08036 13.0557 7.96477 11.9502 7.96477Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1032_37133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealershipSettings);
export default __webpack_public_path__ + "static/media/dealership-settings.9511db98.svg";
export { ForwardRef as ReactComponent };